export enum ReceptionType {
    DryMaterials = 1,
    Glasswares = 2,
}
